/**
 * Social proof & community metrics constants.
 * Single source of truth for user/aspirant counts across the application.
 */

export const SOCIAL_PROOF_COUNT = "10000+";
export const SOCIAL_PROOF_COUNT_FORMATTED = "10,000+";

/**
 * Standard social proof descriptors
 */
export const SOCIAL_PROOF_ASPIRANTS_GROWING_TEXT = `${SOCIAL_PROOF_COUNT} aspirants are already growing faster with Yooki Pro — now it’s your turn.`;
export const SOCIAL_PROOF_COMMUNITY_TEXT = `${SOCIAL_PROOF_COUNT} UPSC aspirants using Yooki to crack Prelims 2026`;
export const SOCIAL_PROOF_USED_BY_TEXT = `Used by ${SOCIAL_PROOF_COUNT} UPSC aspirants and mentors.`;
